<template>
  <div class="tread-other">
    <span style="width:10rem;" class="trend-title">能源类别</span>
    <span style="width:15rem;" class="trend-title">损耗比例</span>
    <div class="tread-input">
      <span class="trend-title">电力</span>
      <el-input type="number" placeholder="请输入" v-model="eleDB">
        <template slot="suffix">%</template>
      </el-input>
      <i class="i-default">低：2%以下   中：2%-5%   高：5%以上</i>
    </div>
    <div class="tread-input">
      <span class="trend-title">水</span>
      <el-input type="number" placeholder="请输入" v-model="waterDB">
        <template slot="suffix">%</template>
      </el-input>
      <i class="i-default">低：5%以下   中：5%-10%   高：10%以上</i>
    </div>
    <div class="tread-input">
      <span class="trend-title">燃气</span>
      <el-input type="number" placeholder="请输入" v-model="gasDB">
        <template slot="suffix">%</template>
      </el-input>
      <i class="i-default">低：0.5%以下   中：0.5%-1%   高：1%以上</i>
    </div>
    <div class="tread-input">
      <span class="trend-title">煤炭</span>
      <el-input type="number" placeholder="请输入" v-model="coalDB">
        <template slot="suffix">%</template>
      </el-input>
      <i class="i-default">低：2%以下   中：2%-5%   高：5%以上</i>
    </div>
    <div class="tread-input">
      <span class="trend-title">燃油</span>
      <el-input type="number" placeholder="请输入" v-model="oilDB">
        <template slot="suffix">%</template>
      </el-input>
      <i class="i-default">低：2%以下   中：2%-5%   高：5%以上</i>
    </div>
    <div class="last-save">
        <el-button :loading="lossLoading" @click="saveLoss" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      lossLoading:false,//加载状态
      linshiID:'',
      //数据
      eleDB:'',//电力
      waterDB:'',//水
      gasDB:'',//燃气
      coalDB:'',//煤炭
      oilDB:'',//燃油
    }
  },
  mounted(){
    this.getLoss()
  },
  methods:{
    //保存数据
    saveLoss(){
      this.lossLoading = true;
      let obj = {
        powerLoss:this.eleDB,
        waterLoss:this.waterDB,
        gasLoss:this.gasDB,
        coalLoss:this.coalDB,
        fuelLoss:this.oilDB,
      }
      if(this.linshiID){
        obj.id = this.linshiID
      }
      apis.saveLoss(obj).then(res=>{
        if(res.code==10000){
          this.lossLoading = false;
          this.$message.success('保存成功');
        }else{
          this.lossLoading = false;
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取数据
    getLoss(){
      apis.getLoss().then(res=>{
        if(res.code==10000){
          let _data = res.data.list[0]
          this.eleDB = _data.powerLoss
          this.waterDB = _data.waterLoss
          this.gasDB = _data.gasLoss
          this.coalDB = _data.coalLoss
          this.oilDB = _data.fuelLoss
          this.linshiID = _data.id
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.tread-other{
  .tread-input{ margin-top: 2px; margin-bottom: 2px;}
  .trend-title{ width: 10rem;}
  .el-input,.el-select{ width: 15rem;}
  .i-default{ margin-left: 1rem;}
}
</style>